import {Currency} from "./currency.enum";

export interface IUserWallet {
    walletId: number;
    accountBalance?: number;
    accountPoints?: number;
    pendingAmount?: number;
    currencyCode: string;
    lastDebitDate?: Date;
    lastCreditDate?: Date;
    isBlocked?: boolean;
}

export class UserWallet implements IUserWallet {
    walletId: number;
    accountBalance?: number;
    accountPoints?: number;
    pendingAmount?: number;
    currencyCode: string;
    lastDebitDate?: Date;
    lastCreditDate?: Date;
    isBlocked?: boolean;

    // * Dynamic constructor
    constructor(obj: IUserWallet = {} as IUserWallet) {

        const {
            walletId = 0,
            accountBalance = 0,
            accountPoints = 0,
            pendingAmount = 0,
            currencyCode = "ALL",
            lastDebitDate = new Date(),
            lastCreditDate = new Date(),
            isBlocked = true
        } = obj;

        this.walletId = walletId;
        this.accountBalance = accountBalance ? accountBalance : 0;
        this.accountPoints = accountPoints ? accountPoints : 0;
        this.pendingAmount = pendingAmount ? pendingAmount : 0;
        this.currencyCode = currencyCode;
        this.lastDebitDate = lastDebitDate;
        this.lastCreditDate = lastCreditDate;
        this.isBlocked = isBlocked;
    }
}

export interface IWalletOverview extends IUserWallet {
    creditInfo: string;
    debitInfo: string;

    creditDate: Date;
    debitDate: Date;
    creditAmount: number;
    debitAmount: number;

    balanceMoney: number;

    currencyId: Currency;
    createdAt: Date;
    iban: string;
}

export class WalletOverview extends UserWallet implements IWalletOverview {
    private _debitInfo: string;
    get debitInfo(): string {
        return this._debitInfo;
    }

    set debitInfo(value: string) {
        this._debitInfo = value;

        if (value) {
            this.debitAmount = +this.debitInfo.split("|")[0].trim();
            this.debitDate = new Date(this.debitInfo.split("|")[1].trim());
        } else {
            this.debitAmount = 0;
            this.debitDate = new Date(1970, 1, 1);
        }
    }

    private _creditInfo: string;
    get creditInfo(): string {
        return this._creditInfo;
    }

    set creditInfo(value: string) {
        this._creditInfo = value;

        if (value) {
            this.creditAmount = +this.creditInfo.split("|")[0].trim();
            this.creditDate = new Date(this.creditInfo.split("|")[1].trim());
        } else {
            this.creditAmount = 0;
            this.creditDate = new Date(1970, 1, 1);
        }
    }

    balanceMoney: number;
    creditDate: Date;
    debitDate: Date;
    creditAmount: number;
    debitAmount: number;
    createdAt: Date;
    iban: string;

    private _currencyId: Currency;
    get currencyId(): Currency {
        return this._currencyId;
    }

    set currencyId(value: Currency) {
        this._currencyId = value;
        if (value) {
            this.currencyCode = Currency[value];
        } else {
            this.currencyCode = "ALL";
        }
    }

    constructor(obj: IWalletOverview = {} as IWalletOverview) {
        super(obj);

        const {
            creditInfo = "",
            debitInfo = "",
            balanceMoney = 0,
            currencyId = 0,
            createdAt = new Date(1970, 1, 1),
            iban = ""
        } = obj;

        this.creditInfo = creditInfo;
        this.debitInfo = debitInfo;
        this.balanceMoney = balanceMoney;
        this.currencyId = currencyId;
        this.createdAt = createdAt;
        this.iban = iban
    }
}
